import { useEffect } from 'react';

export function useFocusOnStepChange(regionRef, onScrollToTop, currentStepIndex) {
  useEffect(() => {
    regionRef.current?.focus();
    onScrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStepIndex]);
}
